import LoanProIndex from '@/views/LoanProCustomers/LoanProIndex.vue';
import LoanProCustomerTable from '@/views/LoanProCustomers/LoanProCustomerTable.vue';
import LoanProCustomerEmails from '@/views/LoanProCustomers/CustomerProfile/LoanProCustomerEmails.vue';
import LoanProCustomerStatements from '@/views/LoanProCustomers/CustomerProfile/LoanProCustomerStatements.vue';
import LoanProCustomerActions from '@/views/LoanProCustomers/CustomerProfile/LoanProCustomerActions.vue';
import LoanProCustomerKBOT from '@/views/LoanProCustomers/CustomerProfile/LoanProCustomerKBOT.vue';
import LoanProCustomerFullStory from '@/views/LoanProCustomers/FullStory/LoanProCustomerFullStory.vue';
import LoanProCustomerProfileProfileIndex from '@/views/LoanProCustomers/CustomerProfile/ProfileIndex.vue';
import LoanProCustomerProfile from '@/views/LoanProCustomers/CustomerProfile/LoanProCustomerProfile.vue';
import LoanProCustomerZendesk from '@/views/LoanProCustomers/Zendesk/LoanProCustomerZendesk.vue';

export default [
  {
    path: 'loanpro-customer',
    name: 'loanpro-customer',
    component: LoanProIndex,
    meta: {
      title: 'LoanPro Customers',
      permission: 'view loan-pro-customers',
    },
    children: [
      {
        path: 'list',
        name: 'loanpro-customer-list',
        component: LoanProCustomerTable,
        meta: {
          title: 'LoanPro Customer List',
          permission: 'view loan-pro-customers::list',
        },
      },
      {
        path: ':customer_id',
        name: 'loanpro-customer-profile-index',
        component: LoanProCustomerProfileProfileIndex,
        meta: {
          title: 'LoanPro Customer Profile',
          permission: 'view loan-pro-customers::profile',
        },
        children: [
          {
            path: 'view',
            name: 'loanpro-customer-profile',
            component: LoanProCustomerProfile,
            meta: {
              title: 'LoanPro Customer Profile',
              permission: 'view loan-pro-customers::profile',
            },
          },
          {
            path: 'emails',
            name: 'loanpro-customer-emails',
            component: LoanProCustomerEmails,
            meta: {
              title: 'LoanPro Customer Emails',
              permission: 'view loan-pro-customers::emails',
            },
          },
          {
            path: 'statements',
            name: 'loanpro-customer-statements',
            component: LoanProCustomerStatements,
            meta: {
              title: 'LoanPro Customer Statements',
              permission: 'view loan-pro-customers::statements',
            },
          },
          {
            path: 'zendesk',
            name: 'loanpro-customer-zendesk',
            component: LoanProCustomerZendesk,
            meta: {
              title: 'LoanPro Customer Zendesk',
              permission: 'view loan-pro-customers::zendesk',
            },
          },
          {
            path: 'actions',
            name: 'loanpro-customer-actions',
            component: LoanProCustomerActions,
            meta: {
              title: 'LoanPro Customer Action Log',
              permission: 'view loan-pro-customers::action-log',
            },
          },
          {
            path: 'kbot',
            name: 'loanpro-customer-kbot',
            component: LoanProCustomerKBOT,
            meta: {
              title: 'KBOT',
              permission: 'view loan-pro-customers::zendesk',
            },
          },
          {
            path: 'fullstory',
            name: 'loanpro-customer-fullstory',
            component: LoanProCustomerFullStory,
            meta: {
              title: 'FullStory',
              permission: 'view loan-pro-customers::fullstory',
            },
          },
        ],
      },
    ],
  },
];
